import { c as _c } from "react/compiler-runtime";
import { Button } from '@sbt-web/ui';
import classes from './index.module.scss';
export const ContactButton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button classes={[classes.button]} design="outline" onClick={_temp}>Contatta</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp() {
  window.dispatchEvent(new CustomEvent("subito:AdView:BtnAuthorReply"));
}